/**
 * Ürün sayfası — varsayılan gramaj.
 * Tema ürün sayfasını ilk gramaj seçili açar (settings.pick_mode: first). Ürünün "Varsayılan gramaj"
 * alanı (custom.varsayilan_gramaj) doluysa ya da ilk gramaj tükenmişse layout/theme.liquid bu dosyayı hedef
 * varyantla yükler; burada o gramajın etiketine tıklanır, böylece fiyat, stok ve sepete ekle butonu
 * temanın kendi varyant akışıyla güncellenir. Adreste ?variant= varsa dosya hiç yüklenmez.
 */
const source = document.getElementById('PgDefaultVariant');

let options = [];
try {
  options = JSON.parse(source?.dataset.options || '[]');
} catch (e) {
  options = [];
}

const apply = () => {
  const picker = document.querySelector('hdt-variant-picker[id$="__main-product"]');
  if (!picker || !options.length) return;
  picker.querySelectorAll('fieldset[data-index]').forEach((fieldset) => {
    const value = options[Number(fieldset.dataset.index)];
    const input = [...fieldset.querySelectorAll('input[type="radio"]')].find((el) => el.value === value);
    if (!input || input.checked) return;
    const label = fieldset.querySelector(`label[for="${CSS.escape(input.id)}"]`);
    (label || input).click();
  });
};

if (options.length) customElements.whenDefined('hdt-variant-picker').then(apply);
